import styled from 'styled-components';
import {
  Divider as SemanticDivider,
  Grid as SemanticGrid,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

import SearchLayoutComponent from '../../../../../../../core/layout-components/search';

const Grid = styled(SemanticGrid)`
  &&& {
    margin-bottom: 15px;
  }
`;

const Title = styled.h4`
  color: ${(props) => props.theme.color.textSecondary};
`;

const Search = styled(SearchLayoutComponent).attrs({
  isWritten: true,
})``;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
`;

const Divider = styled(SemanticDivider)`
  &.ui.divider {
    margin: 15px 0;
  }
`;

const Link = styled.a`
  display: flex;
  flex-direction: row;
`;

const Icon = styled(SemanticIcon)`
  &&& {
    margin-left: 5px;
  }
`;

const NoResults = styled(TextLayoutComponent)`
  margin: auto;
  padding: 10px;
`;

const LabelFirstName = styled(TextLayoutComponent)`
`;

const LabelTranscriptText = styled(TextLayoutComponent)`
  word-wrap: break-word;
`;

export {
  Grid,
  HeaderContainer,
  Search,
  Title,
  Divider,
  Link,
  Icon,
  NoResults,
  LabelFirstName,
  LabelTranscriptText,
};
